import React, { FC } from 'react';
import { TablesNames } from '../../store/tables/tables-context';
import { Table } from '../table/Table';
import { Title } from '../developers/page-components/Title';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';

export const ContactDetailsOrders: FC = () => {
	return (
		<div className="card mb-5">
			<div className="card-body py-0">
				<Table
					name={TablesNames.contactOrderTableData}
					data={[]}
					isLoading={false}
					enableDensityToggle={false}
					enableHiding={false}
					enableFullScreenToggle={false}
					enableColumnActions={false}
					toolbarCustomAction={
						<>
							<Title title='Orders' additionalClass='fs-5 fw-bolder'/>
							<ButtonComponent
								buttonName="Show all"
								additionalClass="no-letter-spacing fs-7 py-1 ps-2 pe-3 d-block ms-auto"
								buttonType={BUTTON_TYPE.TRANSPARENT}

							/>

						</>
					}
				/>
			</div>
		</div>
	);
};